import React from "react"
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent"

const RepaymentOption = () => {
  const data = [
    {
      repaymentOption: "Automatic Deduction",
      desc: "Payments are automatically deducted from your bank account.",
      frequency: "Monthly/Bi-weekly",
      setupRequired: "Bank Account Details",
      additionalNotes: "Ensure sufficient funds in the account.",
    },
    {
      repaymentOption: "Manual Payment",
      desc: "Payments can be made manually through the payment portal.",
      frequency: "Monthly/Custom",
      setupRequired: "None",
      additionalNotes: "Must ensure timely payments",
    },
    {
      repaymentOption: "Automatic Deduction",
      desc: "Adjust payment amounts or frequency based on cash flow.",
      frequency: "Custom",
      setupRequired: "None",
      additionalNotes: "Changes must be agreed upon and may require re-approval",
    },
  ]

  const columns = [
    { name: "Repayment Option", selector: (row) => row.repaymentOption },
    { name: "Description", selector: (row) => row.desc, wrap: true },
    { name: "Frequency", selector: (row) => row.frequency },
    { name: "Setup Required", selector: (row) => row.setupRequired },
    { name: "Additional Notes", selector: (row) => row.additionalNotes, wrap: true },
  ]

  return (
    <div>
      <div className="fw-semibold fs-5 my-3">Repayment Options</div>
      <div className="p-2 bg-white mb-3">
        <div className="border border-subtle-secondary p-3">
          <ul className="mb-0">
            <li>
              <b>Automatic Deduction:</b> Payments are automatically deducted from your bank account on the due date.
            </li>
            <li>
              <b>Manual Payment:</b> Payments can be made manually through the payment portal or via bank transfer.
            </li>
            <li>
              <b>Flexible Payments:</b> Adjust your payment frequency or amount based on your cash flow.
            </li>
          </ul>
        </div>
      </div>

      <DatatableComponent data={data} columns={columns} type={"yellow"} />
    </div>
  )
}

export default RepaymentOption
